module.exports = __webpack_public_path__ + "static/media/AP1.afe36648.webp";